export const PURCHASE_SALE_ORDER_BALANCE_REPORT_REQUEST = 'PURCHASE_SALE_ORDER_BALANCE_REPORT_REQUEST';
export const PURCHASE_SALE_ORDER_BALANCE_REPORT_SUCCESS = 'PURCHASE_SALE_ORDER_BALANCE_REPORT_SUCCESS';
export const PURCHASE_SALE_ORDER_BALANCE_REPORT_FAILURE = 'PURCHASE_SALE_ORDER_BALANCE_REPORT_FAILURE';